export const CALENDAR_PLACEHOLDER_HEIGHT = 210;
